module.exports = __webpack_public_path__ + "static/media/register.d986dc69.svg";